<template>
  <el-dialog
    title="编辑加液器"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="45%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      :inline="true"
      ref="ruleForm"
      label-width="120px"
    >
      <el-form-item label="设备编号" prop="liquidFeederId">
        <el-input
          v-model.trim="ruleForm.liquidFeederId"
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="绑定机器" prop="machineid">
        <el-input v-model.trim="ruleForm.machineid"></el-input>
      </el-form-item>

      <el-form-item label="IMEI" prop="liquidFeederImei">
        <el-input v-model.trim="ruleForm.liquidFeederImei"></el-input>
      </el-form-item>

      <el-form-item label="加液器型号" prop="machineType">
        <el-input v-model.trim="ruleForm.liquidFeederModel"></el-input>
      </el-form-item>

      <el-form-item label="是否可用" prop="machineEnable">
        <el-switch v-model="ruleForm.liquidFeederEnable"></el-switch>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input v-model="ruleForm.remark" placeholder="备注"> </el-input>
      </el-form-item>

      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
// import enumObject from "../../../plugins/enum";
// import agentVendorShop from "@/components/layout/agentVendorShop";

//import { mapGetters } from "vuex";
export default {
  components: {
    // agentVendorShop
  },
  props: ["liquidFeederInfo"],
  data() {
    return {
      ruleForm: {
        id: this.liquidFeederInfo ? this.liquidFeederInfo.id : "",

        liquidFeederId: this.liquidFeederInfo
          ? this.liquidFeederInfo.liquidFeederId
          : "",
        machineid: this.liquidFeederInfo ? this.liquidFeederInfo.machineid : "",
        liquidFeederImei: this.liquidFeederInfo
          ? this.liquidFeederInfo.liquidFeederImei
          : "",
        liquidFeederModel: this.liquidFeederInfo
          ? this.liquidFeederInfo.liquidFeederModel
          : "",
        liquidFeederEnable: this.liquidFeederInfo
          ? this.liquidFeederInfo.liquidFeederEnable
          : true,
        remark: this.liquidFeederInfo ? this.liquidFeederInfo.remark : ""
      },
      rules: {
        machineid: [{ required: true, message: "请输入机器ID" }],
        liquidFeederImei: [{ required: true, message: "请输入加液器IMEI" }]
      }
      // vendorsList: [],
      // shopList: [],
      // vendorListForPrompt: [],
      // shopListForPrompt: [],
      // selectedAvs: {}
    };
  },
  methods: {
    submitForm() {
      console.log(this.ruleForm);
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$axios(this.$urlMapping["编辑加液器"], {
            data: this.ruleForm
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$emit("closeForm");
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
    //handleChangeVendorsList() {
    //  this.ruleForm.machineInShopid = "";
    //}
  },
  computed: {
    // CITY_ENUM() {
    //   return enumObject.CITY_ENUM.filter(ele => ele.value !== "");
    // },
    // MACHINE_STATUS_ENUM() {
    //   return enumObject.MACHINE_STATUS_ENUM.filter(ele => ele.value !== "");
    // },
    // filterShopList() {
    //   if (this.userType === "admin") {
    //     return this.shopList.filter(
    //       ele => ele.shopOwner === this.ruleForm.vendorid
    //     );
    //   } else {
    //     return this.shopList;
    //   }
    // }
  },

  async mounted() {
    // console.log("mounted");
    // console.log(this.liquidFeederInfo);
    // this.selectedAvs = {
    //   selectedAgentid: this.machineInfo.agentid,
    //   selectedVendorid: this.machineInfo.vendorid,
    //   selectedShopid: this.machineInfo.machineInShopid
    // };
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
